import { Space } from 'antd';
import { Layout } from 'components/Layout/Layout';
import { FormattedMessage } from 'react-intl';
import { ReadingGroupsFooter } from './components/ReadingGroupsFooter';
import { ReadingGroupListTable } from './components/Table';
import { ReadingGroupsPage as messages } from './messages';

export const ReadingGroupListPage = () => (
  <Layout footerContent={<ReadingGroupsFooter />} headerContent={<FormattedMessage {...messages.header} />}>
    <Space className="w-100" direction="vertical">
      <ReadingGroupListTable />
    </Space>
  </Layout>
);
